import { defineMessages } from "react-intl";

const messages = defineMessages({
  addNote: {
    id: "grid.editableNoteCell.noteEditor.addNote",
    defaultMessage: "Add Note",
    description: "message for add note button",
  },
  cancel: {
    id: "grid.editableNoteCell.noteEditor.cancel",
    defaultMessage: "Cancel",
    description: "message for cancel button",
  },
  delete: {
    id: "grid.editableNoteCell.noteEditor.deleteNote",
    defaultMessage: "Delete Note",
    description: "message for delete note button",
  },
  deleteConfirm: {
    id: "grid.editableNoteCell.noteEditor.deleteNote.confirm.title",
    defaultMessage: "Delete note?",
    description: "message for delete note confirm modal",
  },
  edit: {
    id: "grid.editableNoteCell.noteEditor.editNote",
    defaultMessage: "Edit Note",
    description: "message for edit note button",
  },
  leaveConfirm: {
    id: "grid.editableNoteCell.noteEditor.edit.leaveConfirm",
    defaultMessage: "Leave without saving changes?",
    description: "message for leave note confirm modal",
  },
  no: {
    id: "grid.editableNoteCell.noteEditor.no",
    defaultMessage: "No",
    description: "message for No button",
  },
  note: {
    id: "grid.editableNoteCell.noteEditor.note",
    defaultMessage: "Note",
    description: "message for note component label",
  },
  placeholder: {
    id: "grid.editableNoteCell.noteEditor.placeholder",
    defaultMessage: "Add note",
    description: "Note field placeholder",
  },
  save: {
    id: "grid.editableNoteCell.noteEditor.save",
    defaultMessage: "Save",
    description: "message for save note button",
  },
  viewNote: {
    id: "grid.editableNoteCell.noteEditor.viewNote",
    defaultMessage: "View Note",
    description: "message for view note button",
  },
  yes: {
    id: "grid.editableNoteCell.noteEditor.yes",
    defaultMessage: "Yes",
    description: "message for Yes button",
  },
});

export default messages;
